import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchQuotationDescriptions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/finance/quotation_descriptions", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchQuotationDescription(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/finance/quotation_descriptions/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editQuotationDescription(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/finance/quotation_descriptions", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteQuotationDescription(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/finance/quotation_descriptions", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
